export default __webpack_public_path__ + "static/media/6.a600fab6.png";